/* eslint-disable no-bitwise */

// keycloak-js v26+ hard-requires `crypto.randomUUID()` for state/nonce generation.
// Some environments (notably HTTP non-localhost) don't expose it, even though
// `crypto.getRandomValues` may still be available. Provide an RFC 4122 v4
// implementation backed by `getRandomValues`.

function ensureCryptoRandomUUID() {
    // Avoid `globalThis` and `self` (CRA eslint: no-undef / no-restricted-globals).
    // This app runs in the browser (window) and in Jest (jsdom window).
    const root =
        (typeof window !== 'undefined' && window) ||
        (typeof global !== 'undefined' && global) ||
        null;
    if (!root) return;

    const { crypto } = root;
    if (!crypto) return;
    if (typeof crypto.randomUUID === 'function') return;
    if (typeof crypto.getRandomValues !== 'function') return;

    crypto.randomUUID = function randomUUID() {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);

        // RFC 4122 v4: set version and variant bits.
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;

        const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
        return (
            hex.slice(0, 8) +
            '-' +
            hex.slice(8, 12) +
            '-' +
            hex.slice(12, 16) +
            '-' +
            hex.slice(16, 20) +
            '-' +
            hex.slice(20)
        );
    };
}

ensureCryptoRandomUUID();
